import moment from 'moment-timezone'

export const formatMMDDYYYY = (date: Date) => {
  return date.toLocaleDateString()
}

export const formatTime = (date: Date) => {
  return date.toLocaleTimeString()
}

export const formatDateTime = (date: Date, timezone: string) => {
  return moment.tz(date, timezone).format('MMM DD, YYYY h:mm A z')
}
